export default "__VITE_ASSET__53d8e9e0__"